import React from "react";
import { useGlobalUtils } from "../../../lib/globalUtils";
import { getUserPhone } from "../../../constants/userConstants";

const OverviewTab = ({
  user,
  ordersCount,
  walletBalance,
  showStats = true,
}) => {
  const { parsePrice, parseDate } = useGlobalUtils();

  // Extract user information
  const phone = getUserPhone(user);
  const email = user?.email || "N/A";
  const address = user?.addresses?.[0] || user?.address;

  return (
    <div className="space-y-6">
      {/* Statistics Cards - Only show for non-admin users */}
      {showStats && (
        <div
          className={`grid grid-cols-1 ${walletBalance ? "md:grid-cols-2" : ""} gap-6`}
        >
          <div className="rounded-lg border border-gray-700 bg-gray-800 p-6">
            <div className="text-center">
              <p className="mb-2 text-sm text-gray-400">Total Orders</p>
              <p className="text-3xl font-bold text-white">{ordersCount}</p>
            </div>
          </div>

          {!!walletBalance && (
            <div className="rounded-lg border border-gray-700 bg-gray-800 p-6">
              <div className="text-center">
                <p className="mb-2 text-sm text-gray-400">
                  Cash Wallet Balance
                </p>
                <p className="text-3xl font-bold text-green-400">
                  {parsePrice(walletBalance)}
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Customer Info */}
      <div className="rounded-lg border border-gray-700 bg-gray-800 p-6">
        <h3 className="mb-4 text-lg font-semibold text-white">Customer Info</h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-400">Phone:</span>
            <span className="text-white">{phone}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Email:</span>
            <span className="text-white">{email}</span>
          </div>
          {!!address?.id && (
            <div className="flex justify-between">
              <span className="text-gray-400">Address:</span>
              <span className="text-white">{address?.address}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-gray-400">Joined:</span>
            <span className="text-white">{parseDate(user?.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
